import React, { useState, useEffect, FC } from 'react'
import Tabs from '../components/Tabs'
import Hero from '../components/Hero'
import Header from '../components/header/Header'
import { useSelector } from 'react-redux'
import { getPageParamSection, getArtworksLength, getAccountUserID } from '../selectors'
import { isAuthenticated, getUserID } from 'selectors/user/session'
import AllArtworks from 'apps/user/artworks/layouts'
import ArtistProfile from './ArtistProfile'
import NoResults from '../components/NoResults'
import Admin from '../components/admin/Admin'
import styles from '../components/artistProfile.module.scss'
import { fetchFollowApi } from 'apis/private/follow'
import { ARTWORKS } from '../helpers/constants'
import classNames from 'classnames'
const Artist: FC = () => {
  const fetchData = async () => {
    const result = await fetchFollowApi()
    setFollowedUserArray(result)
  }
  const authenticated = useSelector(isAuthenticated)
  const sessionUserID = useSelector(getUserID)
  const artistID = useSelector(getAccountUserID)
  const section = useSelector(getPageParamSection)
  const isArtworkPresent = useSelector(getArtworksLength)
  const myOwnAccount = sessionUserID === artistID
  const [followedUserArray, setFollowedUserArray] = useState<ReadonlyArray<number>>([])
  useEffect(() => {
    if (authenticated && !myOwnAccount) {
      fetchData()
    }
  }, [authenticated])
  return (
    <div
      className={classNames(
        {
          [styles.artistProfileAllArtworks]: section === ARTWORKS,
        },
        styles.artistProfile
      )}
    >
      <Hero />
      <div className={styles.pageGrid}>
        <Header followedUserArray={followedUserArray} setFollowedUserArray={setFollowedUserArray} />
        <Admin />
        {isArtworkPresent ? <Tabs /> : <NoResults />}
        {section === 'artworks' ? (
          <AllArtworks />
        ) : (
          <ArtistProfile
            followedUserArray={followedUserArray}
            setFollowedUserArray={setFollowedUserArray}
          />
        )}
      </div>
    </div>
  )
}

export default Artist
